import { render } from "./cpt-audio-option.vue?vue&type=template&id=6a3692bf"
import script from "./cpt-audio-option.vue?vue&type=script&lang=js"
export * from "./cpt-audio-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__